export default {
	setContact(state, contact_data) {
		state.contact_data = contact_data
	},
}
